export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10869.29f8e889.jpg";